<template>
<div>
<ContentOverlay></ContentOverlay>


<div class="content_card" v-if="!$store.state.ui.contentframeloading">


<ContentHeader :title="$route.meta.title"  url="Tickets" :show_button="true" icon="question-circle" buttontype="danger" label="Destek Talepleri"></ContentHeader>

<div class="content_card_content">





<SortableTableExtended ref="datatable" getroute="tickets/admin_all_resolved_tickets" :columns="columns" routename="Ticket" deleteobjectname="ticket" @dataDeleted="getData" :pageble="true"></SortableTableExtended>

</div>





</div>







</div>
</template>

<script>
export default {

  name: 'ResolvedTickets',

  data () {
     return {
      page:0,
      limit:10,
      data:[],
      totalRecords:0,
      columns:[      
      {
        type:"text",
        field:"submitteduser_name",
        header:"kullanici",
        hide_on_mobile:false,
        with_route:true,
      },     
      {
        type:"text",
        field:"supplier_name",
        header:"tedarikci",
        hide_on_mobile:false,
      },    
      {
        type:"text",
        field:"brand_name",
        header:"marka",
        hide_on_mobile:false,
      },    
      {
        type:"text",
        field:"project_name",
        header:"proje",
        hide_on_mobile:false,
      }, 
      {
        type:"text",
        field:"flow_name",
        header:"akis",
        hide_on_mobile:false,
      },
      {
        type:"pill",
        field:"ticket_status",
        header:"durum",
        selectors:["awaiting","resolved","answered"],
        options:[
          {
            name:"awaiting",
            color:"#ff6600",
            text:"degerlendirmede",
          },
          {
            name:"answered",
            color:"#3b82f6",
            text:"cevaplandi",
          },
          {
            name:"resolved",
            color:"#4dc247",
            text:"cozumlendi",
          },
        ],
      },       
      {
        type:"text",
        field:"supportedby.name",
        header:"cevaplayan",
        hide_on_mobile:false,
      },

      {
        type:"date",
        field:"updated_at",
        header:"eklenme_tarihi",
        hide_on_mobile:true,
      },

      ]
    }
  },
  sockets: {
    unsupported_tickets_detected(data) {
      this.$refs.datatable.getData()
    },
  },
   mounted()
  {
    //this.$store.dispatch('tickets/setAdminOpenTickets',false) 
  	//this.getData()
  },
  methods:{
  	async getData()
  	{
  		//this.data = await this.generalApiGet("tickets/admin_all_tickets") 

      data = await this.generalApiGet("tickets/admin_all_resolved_tickets/"+this.page+"/"+this.limit)
      this.totalRecords = await data.meta.total
      this.data = await data.data
      //this.$store.dispatch('tickets/setAdminOpenTickets',false) 
      console.log(this.data);
  	},
    onPage()
    {

    },
  	
  }
};
</script>

<style lang="css" scoped>
</style>